import React, { createContext, useContext, useState, ReactNode } from 'react';
import { LoadingSpinner } from '~/components/global/LoadingSpinner';

interface GlobalLoaderValue {
  showLoader: (message?: string) => void;
  hideLoader: () => void;
  isLoaderVisible: boolean;
  loaderMessage: string;
}

const defaultValue: GlobalLoaderValue = {
  showLoader: () => {},
  hideLoader: () => {},
  isLoaderVisible: false,
  loaderMessage: '',
};

const GlobalLoaderContext = createContext<GlobalLoaderValue>(defaultValue);

export function GlobalLoaderProvider({ children }: { children: ReactNode }) {
  const [
    isLoaderVisible,
    setIsLoaderVisible,
  ] = useState(false);

  const showLoader = () => {
    setIsLoaderVisible(true);
  };

  const hideLoader = () => {
    setIsLoaderVisible(false);
  };

  const value: GlobalLoaderValue = {
    showLoader,
    hideLoader,
    isLoaderVisible,
    loaderMessage: '', // Keine Messages mehr
  };

  return (
    <GlobalLoaderContext.Provider value={value}>
      {children}
      {isLoaderVisible && (
        <div className="fixed inset-0 flex items-center justify-center bg-gray-900 z-[9999]">
          <LoadingSpinner mainLoader={true} />
        </div>
      )}
    </GlobalLoaderContext.Provider>
  );
}

export function useGlobalLoader() {
  const context = useContext(GlobalLoaderContext);
  if (!context) {
    throw new Error('useGlobalLoader must be used within GlobalLoaderProvider');
  }
  return context;
}
